import { createConsumer } from '@rails/actioncable';
import Cookies from 'js-cookie';

import API from "../API"
const URL = API.wsURL;
const consumer = createConsumer(URL + '?access-token=' + Cookies.get('access_token') + '&client=' + Cookies.get('client') + '&uid=' + encodeURIComponent(Cookies.get('uid')));

export default consumer;